<template>
  <el-tooltip
    :content="content"
    :placement="placement"
    :open-delay="openDelay"
    :disabled="disabled"
    effect="dark"
    popper-class="ui-tooltip"
  >
    <slot />
  </el-tooltip>
</template>

<script>
/**
 * AppTooltip — design-system tooltip component.
 * ─────────────────────────────────────────────────────────────────────────
 * Style:    dark navy (#1F2A3A), white text, 14px Inter, no arrow, 8px radius
 * Pattern:  effect="dark" + popper-class="ui-tooltip"
 *
 * Use for:
 *   - Icon hints (ⓘ, ?, ⚠)
 *   - Short single-sentence explanations (≤ ~15 words)
 *   - Labels that are truncated and need a full-text reveal
 *
 * Do NOT use for:
 *   - Multi-sentence descriptions → use AppPopover
 *   - System-level warnings or notices → use AppAlert
 *
 * Usage:
 *   <AppTooltip content="Sync may take up to 5 minutes" placement="right">
 *     <span class="info-icon">i</span>
 *   </AppTooltip>
 *
 * ─────────────────────────────────────────────────────────────────────────
 * TOOLTIP ECOSYSTEM — component ownership map
 * ─────────────────────────────────────────────────────────────────────────
 *
 * SHARED SYSTEM (use these):
 *
 *   AppTooltip      → src/components/common/AppTooltip.vue    (this file)
 *                     Short hover hints. Dark navy card, no arrow.
 *
 *   AppPopover      → src/components/common/AppPopover.vue
 *                     Long explanations. Warm white card, no arrow.
 *
 *   AppAlert        → src/components/common/AppAlert.vue
 *                     System notices. Colored band (not yet created — add when needed).
 *
 * APPROVED EXCEPTIONS (do not migrate — purpose-specific):
 *
 *   ElThTooltip     → src/views/competitors/components/ElThTooltip.vue
 *   ElThTooltipHeight → src/views/HotelReports/Reports_Swiper/ElThTooltipHeight.vue
 *                     Smart overflow-detection wrappers. Show only when text is
 *                     actually truncated. Uses MyelTooltip popper-class + effect="dark".
 *                     Arrow removed globally via is-dark rule in App.vue.
 *                     Exception approved: overflow detection logic is unique to these.
 *
 *   sim-projection-tooltip → src/views/hotel/components/ResponseRate.vue
 *                     Scoped tooltip for the score improvement simulator disclaimer.
 *                     Narrow max-width (210px) intentionally differs from global 320px.
 *                     Arrow removed directly in ResponseRate.vue.
 *                     Exception approved: component-specific constraint.
 *
 * LEGACY / TO MIGRATE EVENTUALLY:
 *
 *   Any remaining el-tooltip without popper-class="ui-tooltip" in hotel dashboard views.
 *   These still render arrows if effect="light" is used. Audit and replace when touching
 *   those files.
 *
 * ─────────────────────────────────────────────────────────────────────────
 */
export default {
  name: 'AppTooltip',
  props: {
    content:   { type: String, required: true },
    placement: { type: String, default: 'top' },
    openDelay: { type: Number, default: 0 },
    // true 时悬停不弹（比如文字没被截断、不需要看全文）
    disabled:  { type: Boolean, default: false },
  },
};
</script>
